import { Box, Toolbar } from "@mui/material";
import { AppBar } from "../appbar/AppBar";
import { Menu } from "../menu/Menu";
import { Outlet } from "react-router-dom";
import { AlertDialog } from "../alerts/AlertDialog";
import { SnackBar } from "../alerts/SnackBar";
import { useWebSockets } from "../../api/useWebSockets";
import { EvaluationReportDialog } from "../evaluation-report-dialog/EvaluationReportDialog";
import { EvaluationReportDialogV2 } from "../evaluation-report-dialog/EvaluationReportDialogV2";
import { useContext } from "react";
import { CollectionsContext } from "./CollectionsProvider";
import { ProcessesSearchDialog } from "../../screens-processes/components/ProcessesSearchDialog";
import { AppDialog } from "../app-dialog/AppDialog";
import { AssistantDialog } from "../assistant-dialog/AssistantDialog";
import { useReservedSlotsCheck } from "../assistant-dialog/useReservedSlotsCheck";
import { LiveCallsDialog } from "../live-calls-dialog/LiveCallsDialog";

export const APP_CONTENT_PADDING = 2

export const AppContent = () => {
    useWebSockets();
    useReservedSlotsCheck();
    const collections = useContext(CollectionsContext);


    return (
        <Box>
            <AppBar />
            <Toolbar />
            <Box display="flex">
                <Menu />
                <Box
                    component="main"
                    sx={{
                        height: "calc(100vh - 64px)",
                        display: "flex",
                        flexDirection: "column",
                        p: APP_CONTENT_PADDING,
                        flexGrow: 1,
                        // Sem isto, o min-width:auto do flex faz o <main> crescer ao conteúdo mais largo
                        // (ex.: a barra de tabs dos dashboards) e empurra a página → scroll horizontal global.
                        minWidth: 0,
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
            <AlertDialog />
            <SnackBar />
            <ProcessesSearchDialog />
            <AppDialog/>
            <AssistantDialog />
            <LiveCallsDialog />
            {collections?.collections.find((collection) => collection.collection === "evaluations") && <EvaluationReportDialog />}
            {collections?.collections.find((collection) => collection.collection === "evaluations") && <EvaluationReportDialogV2 />}
        </Box>
    );
};
